var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8272 5.40056L6.62339 9.41333C6.38453 9.6283 6.02625 9.6283 5.81128 9.38944C5.59631 9.15059 5.59631 8.7923 5.83517 8.57733L9.01194 5.54387H0.890861C0.556463 5.54387 0.317608 5.30501 0.317608 4.97062C0.317608 4.66011 0.556463 4.39736 0.890861 4.39736H9.01194L5.83517 1.38779C5.59631 1.17282 5.59631 0.790648 5.81128 0.575678C6.02625 0.336823 6.40842 0.336823 6.62339 0.551792L10.8272 4.56456C10.9467 4.68399 11.0183 4.8273 11.0183 4.97062C11.0183 5.13782 10.9467 5.28113 10.8272 5.40056Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.5b01fc1c35d69fa98b3a33987df64803.svg";
export { ForwardRef as ReactComponent };